import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Row, Label, Modal, ModalBody, ModalFooter, ModalHeader, Input } from 'reactstrap';
import { AvFeedback, AvField, AvForm, AvGroup, AvInput } from "availity-reactstrap-validation";
import MaterialIcon from "material-icons-react";
import i18n from '../../../../i18next';

import { loadTimezones, updateRestaurant, saveRestaurant, dispatchErrorMessage, clearRestaurant, loadRestaurant } from "../../../../actions/index";
import { localizeCountryNames, isUserAllowedToAddBrands } from '../../../../utils/CommonUtils';
import { countryList, LOW, MEDIUM, HIGH, MENUU_MASTER_ADMIN, MENUU_ADMIN } from '../../../../utils/Constants'
import ManagerScreen from '../../../users/ManagerScreen';

class GeneralScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            id: -1,
            name: '',
            country: '',
            fullAddress: '',
            address: null,
            displayAddress: null,
            city: '',
            location: '',
            phone: '',
            email: '',
            locale: 'en_UK',
            timeZone: '',
            stateAlreadyCopiedFromProps: false,
            managerScreenOpened: false,
            confirmationScreenOpened: false,
            manager: null,
            showMap: false,
            markersOnMap: [],
            managerChanged: false,
            restaurantPriority: null,
            inactive: false
        };

        this.changeState = this.changeState.bind(this);
        this.toggleManagerScreen = this.toggleManagerScreen.bind(this);
        this.assignManager = this.assignManager.bind(this);
    }

    componentWillMount() {
        this.props.loadTimezones();
    }

    componentDidMount() {
        this.loadGoogleLibrary();
    }

    copyStateFromProps() {
        if (this.props.restaurant !== undefined && this.props.restaurant !== null &&
            this.props.restaurant.id !== undefined && this.props.restaurant.id !== -1 &&
            (!this.state.stateAlreadyCopiedFromProps || this.props.restaurant.id !== this.state.id)) {
            this.setState({
                id: this.props.restaurant.id,
                name: this.props.restaurant.name,
                country: this.props.restaurant.address.country,
                city: this.props.restaurant.address.city,
                fullAddress: this.props.restaurant.address.street,
                // address: this.props.restaurant.address,
                address: this.props.restaurant.address,
                displayAddress: this.props.restaurant.displayAddress,
                location: this.props.restaurant.location,
                phone: this.props.restaurant.phone,
                email: this.props.restaurant.email,
                locale: this.props.restaurant.locale,
                timeZone: this.props.restaurant.timeZone,
                manager: this.props.restaurant.manager,
                restaurantPriority: this.props.restaurant.restaurantPriority,
                stateAlreadyCopiedFromProps: true,
                inactive: this.props.restaurant.inactive
            });

        }
    }

    componentDidMount() {
        this.loadGoogleLibrary();
    }

    changeState({ target }) {
        if (target.name === 'country' || target.name === 'city') {
            let updatedAddress = { ...this.state.address };
            updatedAddress[target.name] = target.value;

            this.setState({ ...this.state, address: updatedAddress, [target.name]: target.value });
        } else {

            this.setState({ ...this.state.restaurant, [target.name]: target.value });
        }
    }

    toggleManagerScreen() {
        this.setState({
            managerScreenOpened: !this.state.managerScreenOpened
        });
    }

    loadGoogleLibrary() {
        if (!window.google) {
            let s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = `https://maps.google.com/maps/api/js?key=AIzaSyDIDsCuFwC9HhNt7yK1qojINhgQDrePnmo`;
            let x = document.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
            // Below is important.
            //We cannot access google.maps until it's finished loading
            s.addEventListener('load', e => {
                this.initAutoCompleteService()
            })
        } else {
            this.initAutoCompleteService()
        }
    }

    initAutoCompleteService() {
        let searchField = document.getElementById('restaurantAddress');

        const googleAutoComplete = new window.google.maps.places.Autocomplete(searchField, { types: [] });

        // Listen for when the place is selected from autocomplete dropdown
        googleAutoComplete.addListener('place_changed', () => {

            let place = googleAutoComplete.getPlace();
            let addressSelectedFromPicker = place.formatted_address;

            // let addressParts = this.getAddressParts(place);
            //
            // let formattedAddress = '';
            // if (addressParts.streetName) {formattedAddress += addressParts.streetName + ' '}
            // if (addressParts.streetNumber) {formattedAddress += addressParts.streetNumber + ','}
            // if (addressParts.city) {formattedAddress += addressParts.city + ' '}
            // if (addressParts.country) {formattedAddress += addressParts.country}
            //
            // let updatedAddress = {...this.state.address};
            // updatedAddress.streetNumber = addressParts.streetNumber;
            // updatedAddress.street = addressParts.streetName;
            // updatedAddress.city = addressParts.city;
            // updatedAddress.country = addressParts.country;

            this.setState({
                ...this.state,
                // fullAddress: formattedAddress,
                fullAddress: addressSelectedFromPicker,
                // address: updatedAddress,
                // city: updatedAddress.city
                // country: countryNameToCountryCode(updatedAddress.country),
                // country: '', //reset the country select to trigger the validation
                // location: updatedAddress.street
            }, () => {
                // Get the location of the address and update the address latitude and longitude
                const geocoder = new window.google.maps.Geocoder();
                this.getCoordinatesFromAddress(addressSelectedFromPicker, geocoder);
            });

        });
    }

    getAddressParts(place) {
        let addressParts = {
            streetNumber: null,
            streetName: null,
            city: null,
            country: null
        };

        place.address_components.map((component) => {

            component.types.map((type) => {
                if (type === "street_number") { addressParts.streetNumber = component.long_name }
                // if (type === "route" || type === "neighborhood") {addressParts.streetName = component.long_name}
                if (type === "route") { addressParts.streetName = component.long_name }
                if (type === "locality") { addressParts.city = component.long_name }
                if (type === "country") { addressParts.country = component.long_name }
                if (type === "postal_code") { addressParts.postCode = component.long_name }
            });

        });

        return addressParts;
    }

    getCoordinatesFromAddress(address) {

    }

    assignManager(selectedManager) {
        this.setState({
            managerScreenOpened: !this.state.managerScreenOpened,
            manager: selectedManager,
            managerChanged: true
        });
    }

    updateRestaurant() {
        let regex = /[A-Za-z]/g;
        let isValidPhoneNumber = this.state.phone.match(regex);
        const regexNumbers = /[0-9]/g;
        let newPhone = [];
        this.state.phone.match(regexNumbers).map(singleNumber => {
            newPhone.push(singleNumber);
        });

        if (newPhone > 17) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneTooLong'));
        }

        if (isValidPhoneNumber !== null) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.invalidPhone'));;
        }
        const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

        // Parse number with country code and keep raw input.
        let number = this.state.phone;
        try {
            number = phoneUtil.parseAndKeepRawInput(this.state.phone, this.state.country);
        } catch (error) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneMatchFailure'));
        }

        let validNumber = phoneUtil.isValidNumberForRegion(number, String(this.state.country));
        if (!validNumber) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneMatchFailure'));;
        }

        // If the address entered by the user is not geolocated by google api show error
        if (!this.state.address.latitude || !this.state.address.longitude) {
            return this.props.dispatchErrorMessage(i18n.t('common:validations.addressNotLocated'));
        }

        this.props.updateRestaurant(this.state);
        this.setState({
            managerChanged: false
        });
    }

    saveRestaurant() {
        let regex = /[A-Za-z]/g;
        let isValidPhoneNumber = this.state.phone.match(regex);
        const regexNumbers = /[0-9]/g;
        let newPhone = [];
        this.state.phone.match(regexNumbers).map(singleNumber => {
            newPhone.push(singleNumber);
        });

        if (newPhone > 17) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneTooLong'));
        }

        if (isValidPhoneNumber !== null) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.invalidPhone'));
        }
        const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

        // Parse number with country code and keep raw input.
        const number = phoneUtil.parseAndKeepRawInput(this.state.phone, this.state.country);
        let validNumber = phoneUtil.isValidNumberForRegion(number, String(this.state.country));

        if (!validNumber) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneMatchFailure'));
        }

        // If the address entered by the user is not geolocated by google api show error
        if (!this.state.address.latitude || !this.state.address.longitude) {
            return this.props.dispatchErrorMessage(i18n.t('common:validations.addressNotLocated'));
        }

        this.props.saveRestaurant(this.state, this.props.brand);
        this.setState({
            managerChanged: false
        });
    }

    getFullAddress() {
        let fullAddress = '';
        if (this.props.restaurant.address.street) fullAddress += this.props.restaurant.address.street + ' ';
        if (this.props.restaurant.address.streetNumber) fullAddress += this.props.restaurant.address.streetNumber;
        if (this.props.restaurant.address.city) fullAddress += ', ' + this.props.restaurant.address.city;
        if (this.props.restaurant.address.country) fullAddress += ' ' + localizeCountryNames(this.props.restaurant.address.country);

        return fullAddress;
    }

    renderHeading() {
        const { screenHeading } = styles;

        return (
            <div style={screenHeading}>
                <MaterialIcon icon="settings_applications" color="#0288d1" size={22} />&nbsp;
                {i18n.t('screens:restaurantsMainContainer.general')}
            </div>
        );
    }

    renderRestaurantManager() {
        const { restaurantFieldGroups } = styles;

        let managerMarkup;
        if (this.state.manager == null) {
            managerMarkup = this.renderAssignRestaurantManager();
        } else {
            managerMarkup = this.renderChangeRestaurantManager();
        }

        return (
            <AvGroup style={restaurantFieldGroups}>
                {managerMarkup}
            </AvGroup>
        );
    }

    renderAssignRestaurantManager() {
        const { managerFieldGroups, paragraphStyle } = styles;

        return (
            <div style={managerFieldGroups}>
                <p style={paragraphStyle}>{i18n.t('screens:generalScreen.restaurantManager')}:&nbsp;<Button color="link" onClick={this.toggleManagerScreen}>{i18n.t('common:buttons.assignManager')}</Button></p>
            </div>
        );
    }

    renderChangeRestaurantManager() {
        const { managerFieldGroups, managerDetails, saveWarning, paragraphStyle } = styles;

        const saveWarningMessage = this.state.managerChanged ? i18n.t('common:validations.saveWarningMsg') : '';

        return (
            <div style={managerFieldGroups}>
                <p style={paragraphStyle} >{i18n.t('screens:generalScreen.restaurantManager')}:&nbsp;
                    <span style={managerDetails}>
                        &nbsp; &nbsp;{this.state.manager.name} &nbsp;
                        &nbsp;|&nbsp; {this.state.manager.phone} &nbsp;
                        &nbsp;|&nbsp; {this.state.manager.email} &nbsp;|&nbsp;
                    </span>
                    <Button style={{ paddingTop: '0px', paddingBottom: '0px' }} color="link" onClick={this.toggleManagerScreen}>{i18n.t('common:buttons.changeManager')}</Button>
                    <span style={saveWarning}>{saveWarningMessage}</span>
                </p>
            </div>
        );
    }

    renderRestaurantName() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <Label for="name" style={fieldLabel}>{i18n.t('screens:generalScreen.restaurantName')}</Label>
                <AvInput type="text" name="name" id="restaurantName" placeholder={i18n.t('common:form.name')}
                    style={fieldStyle}
                    value={this.state.name}
                    onChange={this.changeState}
                    maxlength="64"
                    required
                />
                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
            </AvGroup>
        );
    }

    renderRestaurantCountry() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <Label for="country" style={fieldLabel} >{i18n.t('screens:restaurantsScreen.country')}</Label>
                <AvField type="select" name="country" id="restaurantCountry" placeholder={i18n.t('screens:restaurantsScreen.country')}
                    style={fieldStyle}
                    value={this.state.country}
                    onChange={this.changeState}
                    errorMessage={i18n.t('common:validations.errorMsg')}
                    required
                >
                    <option value="">{i18n.t('common:validations.chooseCountry')}</option>
                    {this.renderCountryOptions()}
                </AvField>
            </AvGroup>
        );
    }

    getCordsFromAddress() {
        setTimeout(() => {
            let geocoder = new window.google.maps.Geocoder();

            geocoder.geocode({ 'address': this.state.fullAddress }, (results, status) => {
                if (status === 'OK') {
                    let latitude = results[0].geometry.location.lat();
                    let longitude = results[0].geometry.location.lng();

                    let updatedAddress = { ...this.state.address };
                    updatedAddress.street = this.state.fullAddress;
                    updatedAddress.latitude = latitude;
                    updatedAddress.longitude = longitude;

                    geocoder.geocode({ 'location': results[0].geometry.location }, (results, status) => {
                        if (status === 'OK') {

                            var result = results[0].address_components;

                            for (var i = 0; i < result.length; ++i) {
                                if (result[i].types[0] == "postal_code") {
                                    updatedAddress.zipCode = result[i].long_name;
                                }
                            }
                        }
                    });

                    this.setState({ ...this.state, address: updatedAddress });
                } else { // Open a modal to let user choose its address
                    this.toggleMap();
                    this.getRestaurantLocationFromCity();
                }
            });
        }, 600);
    }

    getRestaurantLocationFromCity() {
        let geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({ 'address': this.state.city }, (results, status) => {
            if (status === 'OK') {
                let latitude = results[0].geometry.location.lat();
                let longitude = results[0].geometry.location.lng();

                let restaurantCords = {
                    lat: latitude,
                    lng: longitude
                };

                this.initMapService(restaurantCords);

            } else {
                alert(`${i18n.t('screens:generalScreen.geocodeFailure')}: ${status}`);

                // Open the map in Europe
                let restaurantCords = {
                    lat: 50.970319,
                    lng: 10.166473
                };

                let customZoom = 4;

                this.initMapService(restaurantCords, customZoom);
            }
        });
    }

    renderRestaurantAddress() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <Label for="address" style={fieldLabel} >{i18n.t('screens:generalScreen.restaurantAddress')}</Label>
                <AvInput autoComplete="on" name="fullAddress" id="restaurantAddress" placeholder={i18n.t('common:form.restaurantAddress')}
                    style={fieldStyle}
                    value={this.state.fullAddress}
                    onChange={this.changeState}
                    onBlur={() => { this.getCordsFromAddress() }}
                    maxlength="255"
                    required
                />
                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
            </AvGroup>
        );
    }

    clearMarkersFromMap() {
        this.state.markersOnMap.map((marker) => {
            marker.setMap(null);
        });
    }

    getAddressFromUserCords(lat, lng, updatedMarkersList) {
        const geocoder = new window.google.maps.Geocoder();
        let latlng = new window.google.maps.LatLng(lat, lng);

        geocoder.geocode({ 'latLng': latlng }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                let formattedAddress = results[0].formatted_address;

                let updatedAddress = { ...this.state.address };
                updatedAddress.street = formattedAddress;
                updatedAddress.latitude = lat;
                updatedAddress.longitude = lng;

                let result = results[0].address_components;

                for (let i = 0; i < result.length; ++i) {
                    if (result[i].types[0] == "postal_code") {
                        updatedAddress.zipCode = result[i].long_name;
                    }
                }

                this.setState({ ...this.state, markersOnMap: updatedMarkersList, address: updatedAddress, fullAddress: formattedAddress });
            }
        });
    }

    initMapService(restaurantCords, customZoom) {

        const map = new window.google.maps.Map(document.getElementById('restaurantAddressMap'), {
            center: { lat: restaurantCords.lat, lng: restaurantCords.lng },
            zoom: customZoom ? customZoom : 13
        });

        window.google.maps.event.trigger(map, 'resize');

        // Listen for when the user clicks on the map to choose his address
        window.google.maps.event.addListener(map, 'click', (event) => {

            // Clear old marker
            this.clearMarkersFromMap();

            let myLatlng = new window.google.maps.LatLng(event.latLng.lat(), event.latLng.lng());

            let marker = new window.google.maps.Marker({
                position: myLatlng,
                map: map,
            });

            let updatedMarkersList = [...this.state.markersOnMap, marker];

            this.getAddressFromUserCords(event.latLng.lat(), event.latLng.lng(), updatedMarkersList);
        });

    }

    toggleMap() {
        this.setState({ ...this.state, showMap: !this.state.showMap }, () => { });
    }

    confirmAddress() {
        if (this.state.markersOnMap.length) {
            this.toggleMap();
        } else {
            return this.props.dispatchErrorMessage(i18n.t('common:validations.selectRestaurantAddressFromMap'));
        }
    }

    renderAddressPickerModal() {
        //add toggle=this.toggleMap.bind(this) to Modal and ModalHeader to allow closing the modal
        return (
            <Modal className='promotions-modal' isOpen={this.state.showMap}>
                <ModalHeader className="modalHeader">{i18n.t('screens:generalScreen.mapAddressModalTitle')}</ModalHeader>
                <ModalBody className='promotions-maker-body'>
                    <h5 style={{ fontSize: 17, margin: '20px 0 30px 0' }}>
                        {i18n.t('screens:generalScreen.mapAddressModalText')}
                    </h5>
                    <div id="restaurantAddressMap" style={{ width: '100%', height: 300 }}></div>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.confirmAddress.bind(this)} className="btn-primary">{i18n.t('common:buttons.confirm')}</Button>
                </ModalFooter>
            </Modal>
        );
    }

    renderDisplayRestaurantAddress() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <Label for="displayAddress" style={fieldLabel} >{i18n.t('screens:generalScreen.restaurantDisplayAddress')}</Label>
                <AvInput autoComplete="off" name="displayAddress" id="displayAddress" placeholder={i18n.t('common:form.restaurantDisplayAddress')}
                    style={fieldStyle}
                    value={this.state.displayAddress}
                    onChange={this.changeState}
                    maxlength="120"
                    required
                />
                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
            </AvGroup>
        );
    }

    renderCountryOptions() {
        return countryList.map((country, i) => {
            return <option key={i} value={country}>{localizeCountryNames(country)}</option>
        });
    }

    renderRestaurantCity() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <Label for="city" style={fieldLabel} >{i18n.t('screens:restaurantsScreen.city')}</Label>
                <AvInput type="text" name="city" id="restaurantCity" placeholder={i18n.t('screens:restaurantsScreen.city')}
                    style={fieldStyle}
                    value={this.state.city}
                    onChange={this.changeState}
                    maxlength="64"
                    required
                />
                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
            </AvGroup>
        );
    }

    renderRestaurantLocation() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <Label for="location" style={fieldLabel}>{i18n.t('screens:restaurantsScreen.location')}</Label>
                <AvInput type="text" name="location" id="restaurantLocation" placeholder={i18n.t('screens:restaurantsScreen.location')}
                    style={fieldStyle}
                    value={this.state.location}
                    onChange={this.changeState}
                    maxlength="64"
                    required
                />
                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
            </AvGroup>
        );
    }

    renderRestaurantPhone() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <Label for="phone" style={fieldLabel} >{i18n.t('common:form.phone')}</Label>
                <AvInput type="phone" name="phone" id="restaurantPhone" placeholder={i18n.t('common:form.phone')}
                    style={fieldStyle}
                    value={this.state.phone}
                    onChange={this.changeState}
                    maxlength="48"
                    required
                />
                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
            </AvGroup>
        );
    }

    renderRestaurantEmail() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <Label for="restaurantEmail" style={fieldLabel} >{i18n.t('common:form.email')}</Label>
                <AvField type="email" name="email" id="restaurantEmail" placeholder={i18n.t('common:form.email')}
                    style={fieldStyle}
                    value={this.state.email}
                    onChange={this.changeState}
                    maxlength="64"
                    required
                    errorMessage={i18n.t('common:validations.errorMsg')}
                // validate={{
                //     pattern: {
                //         value: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$',
                //         errorMessage: i18n.t('common:validations.errorMsgEmail')
                //     }
                //}}
                />
                <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
            </AvGroup>
        );
    }

    renderTimezoneSelect() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <label htmlFor="timeZone" style={fieldLabel}>{i18n.t('screens:generalScreen.timeZone')}</label>
                <AvField type="select" name="timeZone" id="timeZone" placeholder={i18n.t('screens:generalScreen.timeZone')}
                    style={fieldStyle}
                    value={this.state.timeZone}
                    onChange={this.changeState}
                    errorMessage={i18n.t('common:validations.chooseTimeZone')}
                    required
                >
                    <option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
                    {this.props.timezones.map((value, i) => {
                        return (<option key={i}>{value}</option>)
                    })}
                </AvField>
            </AvGroup>
        );
    }

    renderLocaleSelect() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <label htmlFor="locale" style={fieldLabel}>{i18n.t('screens:generalScreen.locale')}</label>
                <AvField type="select" name="locale" id="locale" placeholder={i18n.t('screens:generalScreen.locale')}
                    style={fieldStyle}
                    value={this.state.locale}
                    onChange={this.changeState}
                    errorMessage={i18n.t('common:validations.chooseLanguage')}
                    required
                >
                    <option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
                    <option value="en_UK">{i18n.t('common:languages.english')}</option>
                    <option value="bg_BG">{i18n.t('common:languages.bulgarian')}</option>
                    <option value="fr_FR">{i18n.t('common:languages.french')}</option>
                    {/* <option value="pt_PT">{i18n.t('common:languages.portuguese')}</option> */}
                    <option value="it_IT">{i18n.t('common:languages.italian')}</option>
                    <option value="es_ES">{i18n.t('common:languages.spanish')}</option>
                    <option value="ar_AR">{i18n.t('common:languages.arabic')}</option>
                </AvField>
            </AvGroup>
        );
    }

    renderPriorityLevelSelect() {
        const { restaurantFieldGroups, fieldLabel, fieldStyle } = styles;
        const isUserIsAdminOrMasterAdmin = isUserAllowedToAddBrands(this.props.currentlyLoggedInUser);

        return (
            <Fragment>
                {
                    isUserIsAdminOrMasterAdmin &&

                    <AvGroup style={restaurantFieldGroups}>
                        <label htmlFor="restaurantPriority" style={fieldLabel}>{i18n.t('screens:generalScreen.priorityLevel')}</label>
                        <AvField type="select" name="restaurantPriority" id="restaurantPriority" placeholder={'Priority'}
                            style={fieldStyle}
                            value={this.state.restaurantPriority}
                            onChange={this.changeState}
                        >
                            <option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
                            <option value={LOW}>{i18n.t('screens:generalScreen.low')}</option>
                            <option value={MEDIUM}>{i18n.t('screens:generalScreen.medium')}</option>
                            <option value={HIGH}>{i18n.t('screens:generalScreen.high')}</option>
                        </AvField>
                    </AvGroup>
                }
            </Fragment>
        );
    }

    renderFormSaveButton() {
        const { saveFormButton, restaurantBtnGroups, spaceBetween } = styles;

        return (
            <AvGroup style={restaurantBtnGroups}>
                <Button style={saveFormButton} color="primary">
                    <MaterialIcon icon="save" color="#fff" size={18} />
                    <span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
                </Button>
            </AvGroup>
        );
    }

    isUserDifferentFromMadminOrAdmin(role) {
        if (role === MENUU_MASTER_ADMIN || role === MENUU_ADMIN) {
            return false;
        }

        return true;
    }

    changeInactiveStatus(e) {
        this.setState({ inactive: e.target.checked })
    }

    renderInactiveRestaurantSelect() {
        const { restaurantFieldGroups, checkboxStyle } = styles;

        return (
            <AvGroup style={restaurantFieldGroups}>
                <label htmlFor="inactive" style={{color: '#212529'}}>{i18n.t('screens:generalScreen.deactivate')}</label>
                <Input type="checkbox" 
                style={checkboxStyle}
                checked={this.state.inactive}
                onChange={(e) => this.changeInactiveStatus(e)}
                />
            </AvGroup>
        );
    }
    
    render() {
        this.copyStateFromProps();

        const { containerStyle } = styles;
        const { id } = this.state;
        const { role } = this.props.currentlyLoggedInUser;
        const isLocaleHidden = this.isUserDifferentFromMadminOrAdmin(role);
        return (
            <Container fluid style={containerStyle}>
                <Row>{this.renderHeading()}</Row>
                <div style={{ marginLeft: 15 }}>
                    <AvForm id="restaurantForm" onValidSubmit={(id == -1) ? this.saveRestaurant.bind(this) : this.updateRestaurant.bind(this)}>
                        {this.renderRestaurantName()}

                        {this.renderRestaurantCountry()}

                        {this.renderRestaurantCity()}

                        {this.renderRestaurantAddress()}

                        {this.renderDisplayRestaurantAddress()}

                        {this.renderRestaurantLocation()}

                        {this.renderRestaurantPhone()}

                        {this.renderRestaurantEmail()}

                        {this.renderTimezoneSelect()}

                        {!isLocaleHidden ?
                            this.renderLocaleSelect() : null
                        }

                        {this.renderPriorityLevelSelect()}

                        { this.props.currentlyLoggedInUser.role === MENUU_MASTER_ADMIN ?
                            this.renderInactiveRestaurantSelect() : null
                        }

                        {this.renderRestaurantManager()}

                        {this.renderFormSaveButton()}

                    </AvForm>
                </div>
                <ManagerScreen
                    title={i18n.t('screens:generalScreen.restaurantManager')}
                    role='RESTAURANT_MANAGER'
                    isOpen={this.state.managerScreenOpened}
                    onToggle={this.toggleManagerScreen}
                    onAssign={this.assignManager} />
                {this.renderAddressPickerModal()}
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        brand: state.brand,
        restaurant: state.restaurant,
        timezones: state.timezones,
        currentlyLoggedInUser: state.user
    };
};

export default connect(mapStateToProps, { loadTimezones, updateRestaurant, saveRestaurant, dispatchErrorMessage, clearRestaurant, loadRestaurant })(GeneralScreen);

let styles = {
    containerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        // paddingBottom: 630,
        paddingTop: 10
    },
    saveFormButton: {
        marginBottom: 20,
        marginRight: 20
    },
    restaurantFieldGroups: {
        width: '50%',
        float: 'left',
        marginRight: 10
    },
    restaurantBtnGroups: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    managerFieldGroups: {
        bottom: -10,
        left: 60,
        marginBottom: 20
    },
    managerDetails: {
        fontSize: '14px',
        color: '#000'
    },
    saveWarning: {
        color: '#dc3545',
        fontSize: '80%'
    },
    fieldLabel: {
        float: 'left',
        position: 'absolute',
        marginTop: 10
    },
    fieldStyle: {
        marginLeft: '30%'
    },
    paragraphStyle: {
        color: '#000'
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    spaceBetween: {
        paddingLeft: 4
    },
    sectionStyle: {
        marginBottom: 25,
        backgroundColor: '#fafafa',
        padding: '10px 0px 10px 35px',
        borderLeft: '1px solid #0288d1'
    },
    checkboxStyle: {
        float: 'left',
        position: 'absolute',
        marginLeft: '10%'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/GeneralScreen.js